import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[mailTo]",
})
export class MailToDirective {
  @Input("mailTo") email: string;

  @HostListener("click", ["$event"])
  onClick(event: any): void {
    event.stopPropagation();
    window.location.href = "mailto:" + this.email;
  }
}
